module.exports = __webpack_public_path__ + "img/f6d1959.jpg";